<p-table
	#dt
	styleClass="p-datatable-responsive-demo"
	[value]="laborShiftList"
	[loading]="!laborShiftList"
	[globalFilterFields]="app.keys(laborShiftList)"
	[rowHover]="true"
	[rows]="10"
	[showCurrentPageReport]="true"
	[rowsPerPageOptions]="[10, 25, 50]"
	responsiveLayout="scroll"
	[paginator]="true"
	currentPageReportTemplate="Showing {first} to {last} of {totalRecords} recordName"
>
	<ng-template pTemplate="caption">
		<div class="table-header d-flex">
			<div class="flex-grow-1">
				<span class="p-float-label p-input-icon-left m-2 w-100">
					<i class="pi pi-search"></i>
					<input
						pInputText
						class="w-100"
						id="globalSearch"
						name="globalSearch"
						style="width: 100%"
						type="text"
						(input)="dt.filterGlobal($event.target.value, 'contains')"
					/>
					<label for="globalSearch">Search...</label>
				</span>
			</div>
			<div class="ms-2">
				<app-record-control-footer
					[hideAdd]="false"
					[hideCancel]="true"
					[hideDelete]="true"
					[hideSave]="true"
					(onAddChange)="new()"
				></app-record-control-footer>
			</div>
		</div>
	</ng-template>
	<ng-template pTemplate="header">
		<tr>
			<th pSortableColumn="name">
				<div class="d-flex w-100">
					Shift Name
					<p-sortIcon field="name"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="text" field="name" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
			<th pSortableColumn="name">
				<div class="d-flex w-100">
					Job
					<p-sortIcon field="jobId"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter
							field="jobId"
							matchMode="equals"
							display="menu"
							[showMatchModes]="false"
							[showOperator]="false"
							[showAddButton]="false"
							class="ml-auto"
						>
							<ng-template pTemplate="header">
								<div class="px-3 pt-3 pb-0">
									<span class="font-bold">Job</span>
								</div>
							</ng-template>
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-multiSelect [ngModel]="value" [options]="jobList" optionValue="id" placeholder="Any" (onChange)="filter($event.value)">
									<ng-template let-option pTemplate="item">
										<div class="p-multiselect-representative-option">
											<span class="ml-1">{{ option.name }}</span>
										</div>
									</ng-template>
								</p-multiSelect>
							</ng-template>
						</p-columnFilter>
					</div>
				</div>
			</th>
			<th pSortableColumn="startTime">
				<div class="d-flex w-100">
					Shift Start
					<p-sortIcon field="startTime"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="text" field="startTime" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
			<th pSortableColumn="endTime">
				<div class="d-flex w-100">
					Shift End
					<p-sortIcon field="endTime"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="text" field="endTime" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
			<th>Color Code</th>
		</tr>
	</ng-template>
	<ng-template let-rec pTemplate="body">
		<tr (click)="selectedLaborShift = rec">
			<td>{{ rec.name }}</td>
			<td>{{ rec.jobName }}</td>
			<td>{{ rec.startTime }}</td>
			<td>{{ rec.endTime }}</td>
			<td>
				<span [style.color]="rec.color">
					<fa-icon [icon]="['fas', 'circle']" size="2x"></fa-icon>
				</span>
			</td>
		</tr>
	</ng-template>
</p-table>

<app-employee-labor-shift-record *ngIf="selectedLaborShift" [(laborShift)]="selectedLaborShift"></app-employee-labor-shift-record>
